<div class="sidenav" [ngClass]="{'collapsed-sidebar': isCollapsed, 'sidebar': !isCollapsed}">
    <mat-drawer-container class="drawer-container">
        <mat-drawer class="drawer side-bar-class" mode="side" opened>
            <div class="drawer__header">
                <div class="drawer__header--icon">
                    <div class="hamburger-menu">
                        <mat-icon class="chevron-button" [ngClass]="{'rotated': isCollapsed}" (click)="toggleSidebar()">chevron_left</mat-icon>
                    </div>
                    <img class="ps4-icon" src="assets/images/sect4-logo.svg" alt="Primaria Sectorului 4" />
                    <div class="drawer__header--text">
                        <div class="drawer__header--text--title">{{appName}}</div>
                        <div class="drawer__header--text--title--minWidth">PS 4</div>
                        <div class="drawer__header--text--subtitle faded-text">
                            {{appDescription}}
                        </div>
                        <div class="drawer__header--text--subtitle--minWidth faded-text">
                            inURB 4
                        </div>
                    </div>
                    <div class="drawer__header--social-container">
                        <div class="drawer__header--social" (click)="redirectToinDeskPlatform()">
                            <i class="fa-solid fa-desktop pointer" style="color: #fff"></i>
                            <span class="drawer__header--social--text faded-text pointer">inDesk</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="drawer__buttons">
                <mat-accordion>
                    <p class="menu-link" routerLink="/cereri" [class.menu-active]="'/cereri' === activeOption" (click)="setActive('/cereri')">
                        <img class="sidenav-request-btn" src="../../../../assets/icons/cereri.svg" alt="" />
                        <span>Cereri</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('urbanism-module.documents.official-documents.list')" class="menu-link" routerLink="/registru"
                        [class.menu-active]="'/registru' === activeOption" (click)="setActive('/registru')">
                        <img src="../../../../assets/icons/registru.svg" alt="" />
                        <span>Registru</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('urbanism-module.documents.official-documents.list')" class="menu-link" routerLink="/registru-arhiva"
                        [class.menu-active]="'/registru-arhiva' === activeOption" (click)="setActive('/registru-arhiva')">
                        <img src="../../../../assets/icons/registru.svg" alt="" />
                        <span>Registru Arhivă</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('urbanism-module.documents.official-documents.list')" class="menu-link" routerLink="/confirmare-documente"
                        [class.menu-active]="'/confirmare-documente' === activeOption" (click)="setActive('/confirmare-documente')">
                        <img src="../../../../assets/icons/confirmed-docs.svg" alt="" />
                        <span>Confirmare Documente</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('urbanism-module.settings') || permissionsService.hasPermission('urbanism-module.documents.official-documents-registry.list')"
                        class="menu-link" routerLink="/settings" [class.menu-active]="'/settings' === activeOption" (click)="setActive('/settings')">
                        <img src="../../../../assets/icons/setari.svg" alt="" />
                        <span>Setări</span>
                    </p>

                    <mat-expansion-panel *ngIf="permissionsService.hasPermission('urbanism-module.administrative')" class="sidenav-accordion"
                        (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                            <mat-panel-title class="sidenav-accordion">
                                <div class="panel-title">
                                    <img src="../../../../assets/icons/administrative.svg" alt="" />
                                    <span>Administrativ</span>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p class="settings-option-menu" routerLink="/admin-settings" [class.menu-active]="'/admin-settings' === activeOption" (click)="setActive('/admin-settings')">
                            <img src="../../../../assets/icons/setari.svg" alt="" />
                            <span>Setări</span>
                        </p>
                    </mat-expansion-panel>
                </mat-accordion>

                <div class="footer">
                    <div class="logout-button" (click)="logout()">
                        <img src="assets/icons/logout.svg" alt="Deconectare" />
                        <div click="logout()" class="logout-button--text">Deconectare</div>
                    </div>
                </div>
            </div>
        </mat-drawer>
        <mat-drawer-content class="drawer-content" [style.marginLeft.px]="isCollapsed ? 85 : 280">
            <router-outlet></router-outlet>
        </mat-drawer-content>
    </mat-drawer-container>
</div>